import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';

import React, { useState, useEffect, useRef, useContext } from 'react';

/* ################ IMPORTS OF PRIMEREACT ################*/
import { DataTable } from 'primereact/datatable';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';

import '../../css/Parameters.css';

import ConfigIntegration from '../../integrations/ConfigIntegration';
import { EnvContext } from '../Context/EnvProvider';
import { useAuthToken } from '../../hooks/useAuthToken';

const configIntegration = new ConfigIntegration();

const Parameters = ({ templateId, parameters, setParameters }) => {

    let emptyParameter = {
        parameterName: '',
        parameterValue: '',
        parameterDescription: '',
        modifiable: false,
        advanced: false
    };

    const [parameterDialog, setParameterDialog] = useState(false);
    const [deleteParameterDialog, setDeleteParameterDialog] = useState(false);
    const [parameter, setParameter] = useState(emptyParameter);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [loading, setLoading] = useState(true);
    const toast = useRef(null);
    const { getAccessToken } = useAuthToken();

    const { environment } = useContext(EnvContext);

    useEffect(() => {
        setParameter([]);
        if (templateId) {
            const loadConfig = async () => {
                try {
                    const authToken = await getAccessToken();
                    const data = await configIntegration.getConfig(environment.botApi, templateId, authToken);
                    if (data && data.parameters) {
                        setParameters(data.parameters);
                    }
                    setLoading(false);
                } catch (error) {
                    console.error(error);
                    setLoading(false);
                    toast.current?.show({
                        severity: 'error',
                        summary: 'Erro!',
                        detail: 'Erro ao carregar parâmetros.',
                        life: 5000,
                    });
                }
            };
            
            loadConfig();
        }

    }, [environment.botApi, getAccessToken, setParameters, templateId]);


    const openNew = () => {
        setParameter(emptyParameter);
        setParameterDialog(true);
    }

    const hideDialog = () => {
        setParameterDialog(false);
    }

    const hideDeleteParameterDialog = () => {
        setDeleteParameterDialog(false);
    }

    const saveParameter = () => {

        const parameterName = parameter.parameterName.trim();

        if (parameterName) {
            let _parameters = [...parameters];
            let _parameter = { ...parameter };
            const index = findByParameterName(parameterName);
            if (index >= 0) {
                _parameters[index] = _parameter;
                toast.current.show({ severity: 'success', summary: 'Sucesso!', detail: 'Paramêtro Atualizado', life: 3000 });
            }
            else {
                _parameters.push(_parameter);
                toast.current.show({ severity: 'success', summary: 'Sucesso', detail: 'Paramêtro Criado', life: 3000 });
            }

            setParameters(_parameters);
            setParameterDialog(false);
        }
    }

    const editParameter = (parameter) => {
        setParameter({ ...parameter });
        setParameterDialog(true);
    }

    const confirmDeleteParameter = (parameter) => {
        setParameter(parameter);
        setDeleteParameterDialog(true);
    }

    const deleteParameter = () => {
        let _parameters = parameters.filter(val => val.parameterName !== parameter.parameterName);
        setParameters(_parameters);
        setDeleteParameterDialog(false);
        setParameter(emptyParameter);
        toast.current.show({ severity: 'success', summary: 'Sucesso!', detail: 'Paramêtro Deletado!', life: 3000 });
    }

    const findByParameterName = (parameterName) => {
        let index = -1;
        for (let i = 0; i < parameters.length; i++) {
            if (parameters[i].parameterName === parameterName) {
                index = i;
                break;
            }
        }

        return index;
    }


    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || (e.target && e.target.checked) || '';
        let _parameter = { ...parameter };

        _parameter[`${name}`] = val;

        setParameter(_parameter);
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Novo" icon="pi pi-plus" className="p-button-success p-mr-2" onClick={openNew} />
            </React.Fragment>
        )
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-mr-2" onClick={() => editParameter(rowData)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-warning" onClick={() => confirmDeleteParameter(rowData)} />
            </React.Fragment>
        );
    }

    const header = (
        <div className="table-header">
            <h5 className="p-mx-0 p-my-1">Procurar Parâmetros</h5>
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Procurar..." />
            </span>
        </div>
    );
    const parameterDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Salvar" icon="pi pi-check" className="p-button-text" onClick={saveParameter} />
        </React.Fragment>
    );
    const deleteParameterDialogFooter = (
        <React.Fragment>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={hideDeleteParameterDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={deleteParameter} />
        </React.Fragment>
    );
    const modifiableTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Checkbox inputId="modifiable" checked={rowData.modifiable} readOnly />
                <label htmlFor="modifiable" className="label-modifiable">{rowData.modifiable ? 'Sim' : 'Não'}</label>
            </React.Fragment>
        );
    }
    const advancedeTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Checkbox inputId="advanced" checked={rowData.advanced} readOnly />
                <label htmlFor="advanced" className="label-modifiable">{rowData.advanced ? 'Sim' : 'Não'}</label>
            </React.Fragment>
        );
    }

    return (
        <div className="parameters">
            <Toast ref={toast} />

            <div className="card">
                <Toolbar className="p-mb-4" left={leftToolbarTemplate}></Toolbar>

                <DataTable value={parameters}
                    dataKey="id"
                    loading={loading}
                    globalFilter={globalFilter} header={header} responsiveLayout="scroll">
                    <Column field="parameterName" header="Nome do Parâmetro" sortable style={{ minWidth: '16rem' }}></Column>
                    <Column field="parameterValue" header="Valor" sortable style={{ minWidth: '12rem' }}></Column>
                    <Column field="parameterDescription" header="Descrição" sortable style={{ minWidth: '12rem' }}></Column>
                    <Column header="Modificável" body={modifiableTemplate} sortable style={{ minWidth: '12rem' }}></Column>
                    <Column header="Avançado" body={advancedeTemplate} sortable style={{ minWidth: '12rem' }}></Column>
                    <Column body={actionBodyTemplate} exportable={false} style={{ minWidth: '8rem' }}></Column>
                </DataTable>
            </div>

            <Dialog visible={parameterDialog} style={{ width: '450px' }} header="Detalhes do Paramêtro" modal className="p-fluid" footer={parameterDialogFooter} onHide={hideDialog}>
                <div className="p-fluid p-grid">
                    <div className="p-field p-col-12">
                        <label htmlFor="name">Nome do Paramêtro</label>
                        <InputText id="name" value={parameter.parameterName} onChange={(e) => onInputChange(e, 'parameterName')} required autoFocus />
                    </div>
                    <div className="p-field p-col-12">
                        <label htmlFor="value">Valor do Paramêtro</label>
                        <InputText id="value" value={parameter.parameterValue} onChange={(e) => onInputChange(e, 'parameterValue')} required />
                    </div>
                    <div className="p-field p-col-12">
                        <label htmlFor="description">Descrição do Paramêtro</label>
                        <InputText id="description" value={parameter.parameterDescription} onChange={(e) => onInputChange(e, 'parameterDescription')} required />
                    </div>
                    <div className="p-field p-col-12 p-md-6">
                        <h5 style={{ margin: '1px', marginBottom: '15px' }}>Modificável</h5>
                        <Checkbox inputId="modifiable1" checked={parameter.modifiable} onChange={e => onInputChange(e, 'modifiable')} />
                        <label htmlFor="modifiable1" className="label-modifiable">{parameter.modifiable ? 'Sim' : 'Não'}</label>
                    </div>
                    <div className="p-field p-col-12 p-md-6">
                        <h5 style={{ margin: '1px', marginBottom: '15px' }}>Avançado</h5>
                        <Checkbox inputId="advanced" checked={parameter.advanced} onChange={e => onInputChange(e, 'advanced')} />
                        <label htmlFor="advanced" className="label-modifiable">{parameter.advanced ? 'Sim' : 'Não'}</label>
                    </div>
                </div>
            </Dialog>

            <Dialog visible={deleteParameterDialog} style={{ width: '450px' }} header="Confirme" modal footer={deleteParameterDialogFooter} onHide={hideDeleteParameterDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                    {parameter && <span>Tem certeza de que deseja excluir <b>{parameter.name}</b>?</span>}
                </div>
            </Dialog>
        </div>
    );
}
export default Parameters;
